import { Action, action, actionOn, ActionOn } from "easy-peasy";
import { queryCache, QueryCacheModel } from "./queryCache";
import { draftJobModelV2, DraftJobModelV2 } from "./jobsDraftV2";
import {
  JobResubmissionDraft,
  jobResubmissionDraft,
} from "./jobResubmissionDraft";
import { graphQLClient } from "src/graphql/client";

export interface JobsModel {
  draftV2: DraftJobModelV2;
  resubmissionDraft: JobResubmissionDraft;
  queryCache: QueryCacheModel;
  onDraftReset: ActionOn<JobsModel>;
  jobConfirmed: boolean;
  onJobConfirmed: Action<JobsModel>;
  resetJobConfirmed: Action<JobsModel>;
}
export const jobsModel: JobsModel = {
  draftV2: draftJobModelV2,
  resubmissionDraft: jobResubmissionDraft,
  queryCache: queryCache,
  jobConfirmed: false,
  onDraftReset: actionOn(
    (actions) => actions.draftV2.reset,
    (state) => {
      graphQLClient.cache.evict({
        id: "ROOT_QUERY",
        fieldName: "verticalTalentSearch",
      });
      state.queryCache.createJob = null;
    },
  ),
  onJobConfirmed: action((state) => {
    state.jobConfirmed = true;
  }),
  resetJobConfirmed: action((state) => {
    state.jobConfirmed = false;
  }),
};
